<template>
  <footer>
    <nav class="navbar navbar-expand-sm">
      <div class="row w-100 m-0">
        <div class="col-xl-3 col-lg-5 p-0 border-bottom-md footer-left">
          <ul class="navbar-nav flex-row d-flex">
            <li class="nav-item">
              <a
                class="nav-link-left"
                href="http://linkedin.com/company/flip-africa-ltd"
                target="_blank"
                rel="noopener noreferrer"
              >
                <em class="fab fa-linkedin"></em>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link-left"
                href="https://twitter.com/FLIP_Africa"
                target="_blank"
                rel="noopener noreferrer"
              >
                <em class="fab fa-twitter"></em>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link-left"
                href="https://www.facebook.com/africaflip/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <em class="fab fa-facebook-f"></em>
              </a>
            </li>
            <li
              class="nav-item-left text d-flex align-items-center"
            >&#169; {{(new Date()).getFullYear()}} FLIP Africa</li>
          </ul>
        </div>
        <div class="col-xl-9 col-lg-7 p-0 d-flex footer-right">
          <ul class="navbar-nav menu-footer">
            <li class="nav-item">
              <router-link
                :to="{ path: '/privacy-policy' }"
                class="nav-link text-uppercase"
                target='_blank'
              >PRIVACY POLICY</router-link>
            </li>
            <li class="nav-item">
              <router-link
                :to="{ path: '/terms-of-service' }"
                class="nav-link text-uppercase"
                target='_blank'
              >TERMS OF SERVICE</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ path: '/talents' }" target="_blank" class="nav-link">BROWSE TALENT</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ path: '/jobs' }" target="_blank" class="nav-link">FIND WORK</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ path: '/how-it-works' }" class="nav-link">HOW IT WORKS</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ path: '/contact-us' }" class="nav-link text-uppercase">CONTACT US</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ path: '/about-us' }" class="nav-link text-uppercase">ABOUT US</router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </footer>
</template>
<script>
export default {}
</script>
<style lang="sass" scoped></style>



// WEBPACK FOOTER //
// src/components/Footer.vue